import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import es from './components/local/es'
import en from './components/local/en'
import eus from './components/local/eu'
import fr from './components/local/fr'
import ca from './components/local/ca'
import pt from './components/local/pt_PT'
import de from './components/local/de'
import lv from './components/local/lv'

/**
 * The options the application really initialises i18next with.
 *
 * Exported so a test can assert the resolution behaviour against the SAME object the app uses, not
 * against a copy that can drift away from it -- which is the only way to keep the guarantee below
 * honest.
 *
 * ⚠️ **`lowerCaseLng` is load-bearing, not cosmetic.** Historia 138 registers a customer's own
 * dictionary under a code like `es-acme`. Verified in the installed `i18next@22.5.1`
 * (`formatLanguageCode`, dist/cjs/i18next.js:909-932): for a code containing a hyphen, i18next
 * upper-cases the second part per BCP-47, so `es-acme` resolves as **`es-ACME`** and a bundle
 * registered under the code as written is NEVER found. The user then sees the base language's text
 * with no error anywhere -- no console warning, nothing. Without this option the whole feature dies
 * in silence.
 *
 * ⚠️ And the near miss: **`cleanCode` alone does not fix it.** Read the same function -- `cleanCode`
 * is only consulted in the branch for codes WITHOUT a hyphen (its last line). For `es-acme` it never
 * runs. Only `lowerCaseLng` reaches the branch that matters.
 *
 * It changes nothing for the eight standard languages: none contains a hyphen, all are already
 * lowercase, and for them the option resolves to `code.toLowerCase()`, which is the code itself.
 */
export const I18N_INIT_OPTIONS = {
  lng: 'en',
  lowerCaseLng: true,
  resources: {
    es: {
      translation: es
    },
    en: {
      translation: en
    },
    eus: {
      translation: eus
    },
    pt: {
      translation: pt
    },
    fr: {
      translation: fr
    },
    ca: {
      translation: ca
    },
    de: {
      translation: de
    },
    lv: {
      translation: lv
    }
  },
  fallbackLng: 'en', // set fallback language
  interpolation: {
    escapeValue: false // react already safes from xss
  }
}

i18n
// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
// learn more: https://github.com/i18next/i18next-http-backend
// want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
// .use(Backend)
// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
// .use(LanguageDetector)
// pass the i18n instance to react-i18next.
  .use(initReactI18next)
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
  .init(I18N_INIT_OPTIONS)

export default i18n
